import { Spinner } from '@factorialco/deprecated-design-system'
import { lastDayOfMonth, startOfMonth, subMonths } from 'date-fns'
import {
  InsightsHeadcountPageDocument,
  ReportsInsightsCycleEnum,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { dateToString } from 'modules/core/lib/dates'
import company from 'modules/core/store/collections/companies'

import WidgetTurnoverRate from 'modules/insights/components/WidgetTurnoverRate'
import { useCycleDateRange } from 'modules/insights/hooks/useCycleDateRange'
import Turnover from 'modules/insights/lib/metrics/turnover'

const TurnoverRateWidget = () => {
  const cycleDateRange = useCycleDateRange(() => {
    const currentDate = new Date()

    return {
      cycle: 'monthly',
      startDate: startOfMonth(subMonths(currentDate, 3)),
      endDate: lastDayOfMonth(currentDate),
    }
  })
  const { data, loading, error } = useQuery(InsightsHeadcountPageDocument, {
    variables: {
      companyId: company.current.id,
      cycle: cycleDateRange.cycle as ReportsInsightsCycleEnum,
      startDate: dateToString(cycleDateRange.startDate, 'backend'),
      endDate: dateToString(cycleDateRange.endDate, 'backend'),
    },
  })

  return (
    <>
      {loading && !error && <Spinner />}
      {!loading && !!data && (
        <WidgetTurnoverRate
          turnover={
            new Turnover(
              data.contracts.monthlyHeadcounts,
              data.contracts.leavers,
              data.contracts.joiners
            )
          }
        />
      )}
    </>
  )
}

export default TurnoverRateWidget
